import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class DadosVariavelService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'variavel/dados');
  }

  // Listar com filtros
  listar(filtros: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros.resumo_importacao) {
      params = params.set('resumo_importacao', '1');
    }
    if (filtros.estacao_id) {
      params = params.set('estacao_id', filtros.estacao_id);
    }
    if (filtros.tipo_variavel_id) {
      if (Array.isArray(filtros.tipo_variavel_id)) {
        filtros.tipo_variavel_id.forEach((id: number) => params = params.append('tipo_variavel_id[]', id));
      } else {
        params = params.set('tipo_variavel_id', filtros.tipo_variavel_id);
      }
    }
    if (filtros.data_inicial) {
      params = params.set('data_inicial', filtros.data_inicial);
    }
    if (filtros.data_final) {
      params = params.set('data_final', filtros.data_final);
    }
    if (filtros.order_by) {
      params = params.set('order_by', filtros.order_by);
    }
    if (filtros.order_dir) {
      params = params.set('order_dir', filtros.order_dir);
    }
    if (filtros.per_page) {
      params = params.set('per_page', filtros.per_page);
    }
    if (filtros.page) {
      params = params.set('page', filtros.page);
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  importar(estacaoId: number, dados: any[], somenteNovos: boolean): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}/importar`, { estacao_id: estacaoId, dados, somente_novos: somenteNovos });
  }

  // Filtrar usando POST (endpoint filter)
  filtrar(filtros: any): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}/filter`, filtros);
  }

  // Forçar integração dos dados filtrados
  forcarIntegracao(filtros: any): Observable<any> {
    return this.http.post(`${this.url_base}/${this.prefixo}/forcar-integracao`, filtros);
  }

}

